import React from 'react';

import ButtonField from './Button';
import ConnectWallet from './ConnectWallet';
import CountryField from './Country';
import EmailField from './Email';
import HeadlineText from './Headline';
import Image from './Image';
import Paragraph from './Paragraph';
// import ImageField from './Image';
import DiscordField from './Discord';
import InstagramField from './Instagram';
import LanguageField from './Language';
import NameField from './Name';
import OptInField from './OptIn';
import PhoneField from './Phone';
import QuestionTextField from './QuestionText';
import TelegramField from './Telegram';
import TwitterField from './Twitter';

// Each Rendered can be a component or a function that returns a component
const renderers = {
  headline: (props) => <HeadlineText {...props} />,
  paragraph: (props) => <Paragraph {...props} />,
  image: (props) => <Image {...props} />,
  button: (props) => <ButtonField {...props} />,
  connectWallet: (props) => <ConnectWallet {...props} />,
  country: (props) => <CountryField {...props} />,
  email: (props) => <EmailField {...props} />,
  language: (props) => <LanguageField {...props} />,
  name: (props) => <NameField {...props} />,
  phone: (props) => <PhoneField {...props} />,
  discord: (props) => <DiscordField {...props} />,
  twitter: (props) => <TwitterField {...props} />,
  telegram: (props) => <TelegramField {...props} />,
  instagram: (props) => <InstagramField {...props} />,
  questionText: (props) => <QuestionTextField {...props} />,
  optIn: (props) => <OptInField {...props} />,
};

export const DynamicComponent = React.memo(({ type, field, ...rest }) => {
  const Renderer =
    renderers[type] || (() => <div>No renderer found for {type}</div>);
  return <Renderer field={field} {...rest} />;
});

DynamicComponent.displayName = 'DynamicComponent';
